import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PasswordInput } from '../../components/ui/PasswordInput'
import { AuthLayout, authFormStyles as s } from '@/components/auth/AuthLayout'
import { useAuthStore } from '@/stores/authStore'

export default function RegisterPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const register = useAuthStore((st) => st.register)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setSubmitting(true)
    setError(null)
    try {
      await register({ name, email, password })
      // Signup already emailed a code; the workspace step comes after confirmation.
      navigate('/verify-email', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout
      title={t('auth.register.title', 'Criar conta')}
      subtitle={t('auth.register.subtitle', 'Comece a desenhar seus diagramas em minutos.')}
      footer={
        <span>
          {t('auth.register.haveAccount', 'Ja tem conta?')}{' '}
          <Link to="/login" style={{ color: 'var(--accent)' }}>
            {t('auth.register.login', 'Entrar')}
          </Link>
        </span>
      }
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {error ? <div style={s.error}>{error}</div> : null}
        <div style={s.field}>
          <label style={s.label} htmlFor="name">{t('auth.fields.name', 'Nome')}</label>
          <input id="name" required value={name} onChange={(e) => setName(e.target.value)} style={s.input} />
        </div>
        <div style={s.field}>
          <label style={s.label} htmlFor="email">{t('auth.fields.email', 'E-mail')}</label>
          <input
            id="email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={s.input}
          />
        </div>
        <div style={s.field}>
          <label style={s.label} htmlFor="password">{t('auth.fields.password', 'Senha')}</label>
          <PasswordInput
            id="password"
            required
            autoComplete="new-password"
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={s.input}
          />
        </div>
        <button type="submit" style={s.button} disabled={submitting}>
          {submitting
            ? t('auth.register.submitting', 'Criando...')
            : t('auth.register.submit', 'Criar conta')}
        </button>
      </form>
    </AuthLayout>
  )
}
